import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { RESULT_PAYMENT } from 'shared/api/check-payment'

import { UmrahError } from './components/umrah-error'
import { UmrahPending } from './components/umrah-pending'
import { UmrahSuccess } from './components/umrah-success'

type Props = {
  status: RESULT_PAYMENT
}

export const UmrahPayment = ({ status }: Props) => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(RoutingPaths.umrah.path())
  }

  const goToMyOrders = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <UmrahError onClick={onClick} />
  }

  if (
    status === RESULT_PAYMENT.IN_PROGRESS ||
    status === RESULT_PAYMENT.CREATED ||
    status === RESULT_PAYMENT.LOADING
  ) {
    return <UmrahPending onClick={onClick} />
  }
  return <UmrahSuccess onClick={goToMyOrders} />
}
